module.exports = __webpack_public_path__ + "static/img/el-tenedor-rosa-1.559c6d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/el-tenedor-rosa-1.jpg
// module id = rF7X
// module chunks = 1